<script>
const COLOUR_CLASSES = {
  green: 'bg-green-100 text-green-800 border-green-200',
  red: 'bg-red-100 text-red-800 border-red-200',
  yellow: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  gray: 'bg-gray-100 text-gray-800 border-gray-200',
  grey: 'bg-gray-100 text-gray-800 border-gray-200',
  blue: 'bg-blue-100 text-blue-800 border-blue-200',
  purple: 'bg-purple-100 text-purple-800 border-purple-200',
  orange: 'bg-orange-100 text-orange-800 border-orange-200',
}

export default {
  name: 'LegacyStatusPill',
  props: {
    text: { type: [String, Number], default: '' },
    colour: { type: String, default: 'gray' },
  },
  computed: {
    pillClass() {
      return COLOUR_CLASSES[this.colour] || COLOUR_CLASSES.gray
    },
  },
}
</script>

<template>
  <span
    :class="[
      'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
      pillClass,
    ]"
  >
    {{ text }}
    <slot />
  </span>
</template>
